import React, { Component } from 'react'
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ThresholdUI from './ThresholdUI'
import Typography from '@material-ui/core/Typography';
import config from "../../config/config";
import axios from 'axios';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  }
})

class IconLabelButtons extends Component {
    state = {
        data: this.props.kri.data
    };

    componentWillUpdate(prevProps) {
        if (this.props.kri.id != prevProps.kri.id) {
            this.setState({ updateSuccess: false })
        }
    }

    handleDataUpdate = (e) => {
        console.log(e.target.value)
        this.setState({ data:e.target.value })
    };

    handleDataUpload=()=>{
        let data={
            data: this.state.data,
            report_status: 'Completed'
        }
        return axios.put(config.kri + this.props.kri.id + '/', data)
            .then((res)=>{
                // update data
                this.props.update()
                // clear content
                this.setState({updateSuccess: true })
                // notice
            })
            .catch(err=>{ console.log(err.response); });
    };


    render() {
        const { classes } = this.props;
        console.log("inside upload button")
        console.log(this.props.kri)
        console.log(this.props.kri.data)
        const theme = createMuiTheme({
            palette: {
                primary: {main:'#0091DD'}
            },
            typography: {
                useNextVariants: true
            }
        });
        return (
            <div>
                <TextField
                    style={{margin:'10px', width:'50%'}}
                    id="name"
                    name="due_date"
                    value = {this.state.data}
                    onChange = {(e)=>{this.handleDataUpdate(e)}}
                />

                <MuiThemeProvider theme={theme}>
                    <Button variant="contained"
                        color='primary'
                        component="span"
                        className={classes.button}
                        onClick={()=>{this.handleDataUpload()}}>
                        <CloudUploadIcon className={classes.leftIcon} />
                        Save
                    </Button>
                </MuiThemeProvider>
                {this.state.updateSuccess ? (
                    <Typography style={{ padding: '30px' }}>
                        Data Updated
                    </Typography>
                ) : null }
                <ThresholdUI kri={this.props.kri} value={this.state.data} threshold={this.props.threshold}/>
            </div>
        );
    }
}
IconLabelButtons.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IconLabelButtons);


// WEBPACK FOOTER //
// ./src/components/SharedComponents/KRIMonitoring_updateButton.js